import { render } from "./NewTDASession.vue?vue&type=template&id=e37a9912"
import script from "./NewTDASession.vue?vue&type=script&lang=js"
export * from "./NewTDASession.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__